import PropTypes from "prop-types";
import { Flex } from "rebass";
import { ColorTooltip } from "../common/ColorTooltip";
const ColorBoxMobile = ({
  onClick,
  colorDescription,
  rgbColor,
  id,
  type,
  code,
}) => {
  return (
    <Flex
      bg="#f3f3f3"
      p="10px"
      minWidth="95px"
      maxWidth="95px"
      justifyContent="center"
      flexDirection="column"
      onClick={onClick}
    >
      <span
        style={{
          fontWeight: "bold",
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {colorDescription}
      </span>

      <ColorTooltip
        id={id}
        code={code}
        colorDescription={colorDescription}
        rgb={rgbColor}
        componentName={"catalogueGrillReorderSwapAndPopup"}
        type={type}
      />
    </Flex>
  );
};

ColorBoxMobile.defaultProps = {
  onClick: () => {},
  colorDescription: "",
  rgbColor: "",
  id: "",
  type: "",
  code: "",
};

ColorBoxMobile.propTypes = {
  onClick: PropTypes.func,
  colorDescription: PropTypes.string,
  rgbColor: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  code: PropTypes.string,
};

export { ColorBoxMobile };
